import { render, staticRenderFns } from "./after_detail.vue?vue&type=template&id=d12ea3ce&scoped=true"
import script from "./after_detail.vue?vue&type=script&lang=ts"
export * from "./after_detail.vue?vue&type=script&lang=ts"
import style0 from "./after_detail.vue?vue&type=style&index=0&id=d12ea3ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12ea3ce",
  null
  
)

export default component.exports